import React from 'react';
import './Projects.css';
import Upwork from "../../img/Upwork.png";
import Fiverr from "../../img/fiverr.png";
import amazon from "../../img/amazon.png";
import Shopify from "../../img/Shopify.png";
import Facebook from "../../img/Facebook.png";
import {themeContext} from '../../Context';
import { useContext } from "react";
// import {motion} from "framer-motion";



const Projects = () => {
    const theme = useContext (themeContext);
    const darkMode = theme.state.darkMode;
  return (
    <div className = 'Projects'>
        <div className="awesome">
            <span style={{color: darkMode? 'white': ''}}>Works for All these</span>
            <span>Clients</span>
            <spane>Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                <br></br>
                 Nunc lobortis rhoncus nibh sit amet porttitor</spane>
                 <button className="button s-button">Hire Me</button>
                 <div className="blur s-blur" style={{ background: '#ABF1FF94'}}></div>
            </div>

            <div className='w-right'>
            <div 
            initial = {{rotate: 45}}
            whileInView = {{rotate: 0}}
            viewport = {{margin: '-40px'}}
            transition = {{duration: 3.5 , type: 'spring'}}
            
            className='w-maincircle'>
                <div className='w-secondarycirlce'>
                    <img src= {Upwork} alt="" />
                </div>
                <div className='w-secondarycirlce'>
                    <img src= {Fiverr} alt="" />
                    </div>
                <div className='w-secondarycirlce'>
                    <img src= {amazon} alt="" />
                    </div>
                <div className='w-secondarycirlce'>
                    <img src= {Shopify} alt="" />
                    </div>
                <div className='w-secondarycirlce'>
                    <img src= {Facebook} alt="" />
                    </div>
                </div>
                <div className='w-backCircle blueCircle'></div>
                <div className='w-backCircle yellowCircle'></div>

           

            
           

            
            </div>

    </div>
    
  )
}

export default Projects